export default function UDP(logger)
{
    
    this.config = function(){}.bind(this);
    this.config._hostPort = 0;
    this.config._remotePort = 3000;
    this.config._targetIpAddress = '255.255.255.255';
    this.config._udpMessage = "Hey Luxin!";
    this.config._maxFindHubRetry = 3;
    this.config._findHubRetryDelayMs = 1000;


    this._responseBuffer = [];
    this._findHubRetryCounter = 0;
    this._findHubSetTimeoutHandle = -1;
    this._foundHubSuccessCB = null;

    this._desiredHubUUID = null;


    this.findHub = function(hubUUID, successCB, failCB)
    {
        logger.log("UDP.findHub() :", "find hub called");
        console.log("UDP.findHub() :", "find hub called");

        this._foundHubSuccessCB = successCB;
        this._desiredHubUUID = hubUUID;

        this._findHubRetryCounter++;
        if(this._findHubRetryCounter <= this.config._maxFindHubRetry){
            logger.log("UDP.findHub() :", "attemp " + this._findHubRetryCounter + " of " + this.config._maxFindHubRetry);
            console.log("UDP.findHub() 1 :", "attemp " + this._findHubRetryCounter + " of " + this.config._maxFindHubRetry);
            this._send(this.utility._stringToArraybuffer(this.config._udpMessage));
            console.log("UDP.findHub(): udp message sended")
            clearTimeout(this._findHubSetTimeoutHandle);
            this._findHubSetTimeoutHandle = setTimeout(function()
            {
                logger.log("UDP.findHub() :", "no answer, retrying");
                console.log("UDP.findHub() :", "no answer, retrying");
                this.findHub(hubUUID, successCB, failCB);
            }.bind(this), this.config._findHubRetryDelayMs);
        }else{
            logger.log("UDP.findHub() :", "out of attemps, calling failCB");
            console.log("UDP.findHub() :", "out of attemps, calling failCB");
            this._findHubRetryCounter = 0;
            this._cleanUpUDP();
            failCB();
        }
    }.bind(this);




    this._send = function(buf)
    {
        console.log("_send 1")
        this._cleanUpUDP();
        console.log("UDP._send() :", "sending packet over udp port " + this.config._remotePort);
        chrome.sockets.udp.create(function(createInfo) {
            chrome.sockets.udp.bind(createInfo.socketId, '0.0.0.0', this.config._hostPort, function() {
                chrome.sockets.udp.setBroadcast(createInfo.socketId, true, function() {
                    chrome.sockets.udp.send(createInfo.socketId, buf, this.config._targetIpAddress, this.config._remotePort, function(result) {
                        if (result.resultCode < 0) {
                            console.log("UDP._send() :", "sending failed!", result.resultCode);
                            this._cleanUpUDP();
                        } else {
                            console.log("UDP._send() :", "packet sent successfully", result,result.resultCode);
                            this._addReceiveEventListeners();
                        }
                    }.bind(this));
                }.bind(this));
            }.bind(this));
        }.bind(this));
    }.bind(this);


    this._cleanUpUDP = function()
    {
        logger.log("UDP._cleanUpUDP() :", "cleaning up UDP contex");
        console.log("UDP._cleanUpUDP() :", "cleaning up UDP contex");
        this._responseBuffer = [];
        console.log("clean 1");
        this._removeReceiveEventListeners();
        console.log("clean 2");
        this._closeAllSockets();
        console.log("clean 3")
    }.bind(this);


    this._closeAllSockets = function()
    {
        logger.log("UDP._closeAllSockets() :", "start closing all sockets");
        chrome.sockets.udp.getSockets(function(sockets) {
            for(var i=0;i<sockets.length;i++){
                logger.log("UDP._closeAllSockets() :", "socket " + sockets[i].socketId + " closed");
                chrome.sockets.udp.close(sockets[i].socketId);
            }
        });
    }.bind(this);


    this._addReceiveEventListeners = function()
    {
        logger.log("UDP._addReceiveEventListeners() :", "adding udp receive event listeners");
        chrome.sockets.udp.onReceive.addListener(this._receiver);
        chrome.sockets.udp.onReceiveError.addListener(this._receiveOnError);
    }.bind(this);


    this._removeReceiveEventListeners = function()
    {
        logger.log("UDP._removeReceiveEventListeners() :", "removing udp receive event listeners");
        console.log("UDP._removeReceiveEventListeners() :", "removing udp receive event listeners");
        chrome.sockets.udp.onReceive.removeListener(this._receiver);
        chrome.sockets.udp.onReceive.removeListener(this._receiveOnError);
    }.bind(this);


    this._receiver = function(info)
    {
        var hubUUID = '';
        this.responseBuffer = new Uint8Array(info.data);
        //extracting hub uuid from responseBuffer
        for(var i = 0; i < this.responseBuffer.length; i++){
            hubUUID += String.fromCharCode(this.responseBuffer[i]);
        }
        hubUUID = parseInt(hubUUID);
        logger.log("UDP._receiver() :", "received: hubuuid: " + hubUUID + " from ip: " + info.remoteAddress);
        logger.log("UDP._receiver() :", "Found Luxin Hub, calling successCB");
        console.log("UDP._receiver() :", "Found Luxin Hub, calling successCB");

        if(!isNaN(hubUUID)){
            if(hubUUID == this._desiredHubUUID){
                clearTimeout(this._findHubSetTimeoutHandle);
                this._cleanUpUDP();
                if(typeof(this._foundHubSuccessCB) === 'function'){
                    this._findHubRetryCounter = 0;
                    this._foundHubSuccessCB(info.remoteAddress);
                    this._foundHubSuccessCB = null;
                }
            }
        }
    }.bind(this);


    this._receiveOnError = function()
    {
        logger.log("UDP._receiveOnError() :", "receive error!");
        console.log("UDP._receiveOnError() :", "receive error!")
        this._cleanUpUDP();
    }.bind(this);





    this.utility = function(){}.bind(this);
    this.utility._stringToArraybuffer = function(str)
    {
        logger.log("UDP.utility._stringToArraybuffer() :", "converting string   '" + str + "'   to array buffer");
        var strLength = str.length;
        var outputArrayBuffer = new ArrayBuffer(strLength);
        var outputArrayBufferUint8Array = new Uint8Array(outputArrayBuffer);
        for (var i = 0; i < strLength; i++) {
            outputArrayBufferUint8Array[i] = str.charCodeAt(i);
        }
        return outputArrayBuffer;
    }

}